import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  FaSignInAlt, FaHome, FaInfoCircle, FaBriefcase, FaEnvelope, FaBars, 
  FaUser, FaClipboardList, FaNewspaper, 
  
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const Header = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname);

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location]);

  // Vérifie si un item parent doit être actif
  const isParentActive = (item) => {
    if (activeMenu === item.path) return true;
    if (item.subItems && item.subItems.some(sub => activeMenu.startsWith(sub.path))) {
      return true;
    }
    return false;
  };

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById("mobileMenu");
    if (offcanvasElement) {
      const bsOffcanvas = window.bootstrap?.Offcanvas?.getInstance(offcanvasElement);
      if (bsOffcanvas) bsOffcanvas.hide();
    }
  };

  const handleNavClick = (path) => {
   setActiveMenu(path);
   closeOffcanvas();
  if (window.location.pathname !== path) {
    window.location.href = path; // 🔥 recharge la page complètement
  } else {
    // Sinon scroll normal si on est déjà sur la page
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  };


  const navItems = [
    { path: "/", label: "Accueil", icon: <FaHome /> },
    { path: "/cinef-ec", label: "CINEF-EC", icon: <FaInfoCircle /> },
    {
      path: "/expertises",
      label: "Nos expertises",
      icon: <FaBriefcase />,
      dropdown: true,
      scrollable: true, 
      subItems: [
        { path: "/expertises", label: "Tous nos services" },
        {
          path: "/services/comptabilite-fiscalite",
          label: "Comptabilité - Fiscalité",
        },
        { path: "/services/audit", label: "Audit" },
        { path: "/services/controle-gestion", label: "Contrôle de Gestion" },
        {
          path: "/services/consolidation-comptes",
          label: "Consolidation des Comptes",
        },
        {
          path: "/services/conseil-strategie-entreprise",
          label: "Conseil et Stratégie d'Entreprise",
        },
        { path: "/services/corporate-finance", label: "Corporate Finance" },
        {
          path: "/services/rse-developpement-durable",
          label: "RSE - Développement Durable",
        },
        {
          path: "/services/gestion-patrimoine",
          label: "Gestion du patrimoine",
        },
        {
          path: "/services/paie-gestion-salaries",
          label: "Paie et gestion des salariés",
        },
        {
          path: "/services/droit-affaires-contentieux",
          label: "Droit des affaires et contentieux",
        },
        {
          path: "/services/creation-transformation-entreprise",
          label: "Accompagnement à la création et transformation d'entreprise",
        },
        {
          path: "/services/montage-projets-business-plan",
          label: "Montage de projets et business plan",
        },
        {
          path: "/services/conseils-accompagnement-juridique",
          label: "Conseils et accompagnement juridique",
        },
        {
          path: "/services/solutions-informatiques-securite",
          label: "Solutions informatiques et de sécurité",
        },
        {
          path: "/services/banques-finances",
          label: "Banques Finances et Assurances",
        },
      ],
    },
    {
      path: "/profil",
      label: "Votre profil",
      icon: <FaUser />,
      dropdown: true,
      subItems: [
        { path: "/createur-repreneurs", label: "Créateurs et repreneurs" },
        { path: "/entrepreneurs", label: "Entrepreneurs et professionnels" },
        { path: "/pme-eti", label: "PME, ETI et Grandes Entreprises" },
      ],
    },
    {
      path: "/activites",
      label: "Votre Activité",
      icon: <FaClipboardList />,
      dropdown: true,
      scrollable: true, 
      subItems: [
        {
          path: "/mecaniques-et-transformations",
          label: "Mécaniques et transformations",
        },
        {
          path: "/batiments-et-travaux-publics",
          label: "Bâtiments et travaux publics",
        },
        { path: "/administration-publique", label: "Administration publique" },
        {
          path: "/industrie-agricole",
          label: "Industrie Agricole et de transformation",
        },
        { path: "/profession-liberale", label: "Profession Libérale" },
        {
          path: "/association-ong-fondations",
          label: "Association ONG et Fondations",
        },
        { path: "/societe-cooperative", label: "Société Coopérative" },
        {
          path: "/etablissement-scolaire",
          label: "Établissement Scolaire et Universitaire",
        },
        { path: "/projets-developpement", label: "Projets de développement" }, 
        {
          path: "/hotellerie-restauration",
          label: "Hôtellerie et Restauration",
        },
        {
          path: "/art-culture-divertissement",
          label: "Industrie de l'Art, de la Culture et du Divertissement",
        },
        { path: "/primo-entrepreneurs", label: "Primo entrepreneurs" },
        { path: "/immobilier", label: "Sociétés et agences immobilières" },
        { path: "/startup", label: "Startup" },
        { path: "/commerce", label: "Commerce Général " },
      ],
    },
    {
      path: "/actualites",
      label: "Actualités",
      icon: <FaNewspaper />,
      dropdown: true,
      subItems: [
        { path: "/actualites", label: "Toutes les actualités" },
        {
         path: "https://cinef-bj.com",
         label: "Nos Formations",
         target: "_blank",
          rel: "noopener noreferrer",
         external: true,
        },
        { path: "/actualites/events", label: "Événements" },
        { path: "/actualites/blog", label: "Blog" },
      ],
    },
    { path: "/contact", label: "Contact", icon: <FaEnvelope /> },
  ];

  return (
    <>
      {/* Header principal */}
      <header className="main-header">
        {/* <div className="topbar d-none d-lg-block" style={{ marginTop: '60px', padding: '10px 0' }}>
          <div className="container d-flex justify-content-end align-items-center">
            <Link to="https://www.cinef-bj.com/recrutement" target="_blank" className="topbar-link">
              <span className="topbar-icon">👥</span> Nous rejoindre
            </Link>
            <span className="divider">|</span>
            <Link to="/contact" className="topbar-link">
              <span className="topbar-icon">✉️</span> Contact
            </Link>
            <span className="divider">|</span>
            <Link to="https://www.linkedin.com/company/cinef-ec/" target="_blank" className="topbar-link">
              <FaLinkedin className="topbar-icon" /> LinkedIn
            </Link>
          </div>
        </div> */}

        <nav className="relative navbar navbar-expand-lg navbar-dark">
          {/* <div
            className="topbar d-none d-lg-block"
            style={{ marginTop: "75px", padding: "10px 0" }} >
         
            <div className="container d-flex justify-content-end align-items-center">
              <Link
                to="https://www.cinef-bj.com/recrutement"
                target="_blank"
                className="topbar-link"
              >
                <span className="topbar-icon">👥</span> Nous rejoindre
              </Link>
              <span className="divider">|</span>
              <Link to="/contact" className="topbar-link">
                <span className="topbar-icon">✉️</span> Contact
              </Link>
              <span className="divider">|</span>
              <Link
                to="https://www.linkedin.com/company/cinef-ec/"
                target="_blank"
                className="topbar-link"
              >
                <FaLinkedin className="topbar-icon" /> LinkedIn
              </Link>
            </div>
          </div> */}
          <div className="container">
            <div className="logo-container">
              <Link to="/" className="navbar-brand">
                <img
                  src="../assets/images/cinef.png"
                  alt="CINEF Logo"
                  className="logo"
                />
              </Link>
            </div>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mobileMenu"
            >
              <FaBars />
            </button>

            {/* Menu Desktop */}
            <div className="collapse navbar-collapse justify-content-center">
              <ul className="navbar-nav">
                {navItems.map((item) => (
                  <li
                    key={item.path}
                    className={`nav-item ${item.dropdown ? "dropdown" : ""}`}
                  >
                    {item.dropdown ? (
                      <>
                        <span
                          className={`nav-link dropdown-toggle ${
                            isParentActive(item) ? "active-menu" : ""
                          }`}
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {item.label}
                        </span>
                        <ul
                          className={`dropdown-menu ${
                            item.scrollable ? "scrollable-dropdown" : ""
                          }`}
                        >
                          {item.subItems.map((subItem) => (
                            <li key={subItem.path}>
                              <Link
                                to={subItem.path} target={subItem.target} rel={subItem.rel}
                                className={`dropdown-item ${activeMenu === subItem.path ? "active" : ""}`}
                                onClick={() => setActiveMenu(subItem.path)}
                              >
                                {subItem.label}
                              </Link>
                            </li>

                          ))}
                        </ul>
                      </>
                    ) : (
                      <Link
                        to={item.path}
                        className={`nav-link ${
                          isParentActive(item) ? "active-menu" : ""
                        }`}
                        onClick={() => setActiveMenu(item.path)}
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <Link
              to="/login"
              className="btn btn-login ms-auto d-none d-lg-block"
            >
              <FaSignInAlt className="me-1" /> Connexion
            </Link>
          </div>
        </nav>

        {/* Offcanvas Mobile */}
        <div className="offcanvas offcanvas-start text-bg-dark" id="mobileMenu">
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">Menu CINEF</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="offcanvas"
            ></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav">
              {navItems.map((item) => (
                <li key={item.path} className="nav-item">
                  {item.dropdown ? (
                    <div className="mobile-dropdown">
                      <div
                        className="nav-link mobile-nav-link dropdown-toggle"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${item.label.replace(
                          /\s+/g,
                          ""
                        )}`}
                      >
                        {item.icon} {item.label}
                      </div>
                      <div
                        className="collapse"
                        id={`collapse${item.label.replace(/\s+/g, "")}`}
                      >
                        <ul
                          className={`submenu-list ${
                            item.scrollable ? "scrollable-submenu" : ""
                          }`}
                        >
                          {item.subItems.map((subItem) => (
                            <li key={subItem.path}>
                              {subItem.external ? (
                                <a
                                  href={subItem.path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="submenu-link"
                                  onClick={closeOffcanvas}
                                >
                                  {subItem.label}
                                </a>
                              ) : (
                                <Link
                                  to={subItem.path}
                                  className={`submenu-link ${
                                    activeMenu === subItem.path ? "active" : ""
                                  }`}
                                  onClick={() => handleNavClick(subItem.path)}
                                >
                                  {subItem.label}
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to={item.path}
                      className={`nav-link mobile-nav-link ${
                        isParentActive(item) ? "active-menu" : ""
                      }`}
                      onClick={() => handleNavClick(item.path)}
                    >
                      {item.icon} {item.label}
                    </Link>
                  )}
                </li>
              ))}
              <li className="nav-item mt-4">
                <Link
                  to="/login"
                  className="btn btn-login-mobile"
                  onClick={closeOffcanvas}
                >
                  <FaSignInAlt className="me-1" /> Connexion
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {/* Espaceur pour éviter le chevauchement du contenu */}
      {/* <div className="header-spacer"></div> */}

      <style>{`
        /* Barre supérieure */
        .topbar {
          background: linear-gradient(to right, #f8f9fa, #e9ecef);
          color: #333;
          padding: 8px 0;
          font-size: 14px;
          border-bottom: 1px solid rgba(220,53,69,0.2);
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 1060;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .topbar-link {
          color: #333;
          text-decoration: none;
          padding: 0 10px;
          font-weight: 500;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;
        }

        .topbar-link:hover {
          color: #dc3545;
          transform: translateY(-1px);
        }

        .topbar-icon {
          margin-right: 5px;
          font-size: 16px;
          color: #dc3545;
        }

        .divider {
          color: #aaa;
          padding: 0 8px;
        }

        /* Header principal */
        .main-header {
          position: fixed;
          top: 0px;
          left: 0;
          right: 0;
          z-index: 1050;
          width: 100%;
        }

        .navbar {
          background: linear-gradient(to right, #dc3545, #008A44);
          padding: 10px 0;
          box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
        }

        .logo-container {
          border-radius: 8px;
          padding: 5px 10px;
          margin-right: 15px;
        }

        .logo {
          height: 50px;
          filter: drop-shadow(0 2px 2px rgba(0,0,0,0.1));
        }

        .nav-link {
          color: white;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 10px 15px;
          margin: 0 5px;
          position: relative;
          border-radius: 4px;
        }

        .nav-link:hover {
          color: #ffc107;
          background-color: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }

        .active-menu {
          color: #ffc107 !important;
        }

        /* Dropdown styling */
        .dropdown-menu {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 8px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.2);
          border: none;
          padding: 10px 0;
          min-width: 200px;
          margin-top: 10px;
        }

        /* Ajout du style pour les dropdown scrollable */
        .scrollable-dropdown {
          max-height: 400px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #dc3545 rgba(0,0,0,0.1);
        }

        /* Style pour les scrollbars personnalisées (Chrome, Edge, Safari) */
        .scrollable-dropdown::-webkit-scrollbar {
          width: 6px;
        }

        .scrollable-dropdown::-webkit-scrollbar-track {
          background: rgba(0,0,0,0.1);
          border-radius: 10px;
        }

        .scrollable-dropdown::-webkit-scrollbar-thumb {
          background: #dc3545;
          border-radius: 10px;
        }

        .scrollable-dropdown::-webkit-scrollbar-thumb:hover {
          background: #bd2130;
        }

        .dropdown-item {
          padding: 8px 20px;
          font-weight: 500;
          transition: all 0.2s ease;
          position: relative;
        }

        .dropdown-item:hover {
          background-color: rgba(220, 53, 69, 0.1);
          color: #dc3545;
          transform: translateX(5px);
        }

        .dropdown-item.active {
          background-color: rgba(220, 53, 69, 0.1);
          color: #dc3545;
          font-weight: 600;
        }

        .btn-login {
          background: linear-gradient(to right, #ffc107, #ff9800);
          border: none;
          color: #fff;
          font-weight: 600;
          padding: 8px 20px;
          border-radius: 30px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.2);
          transition: all 0.3s ease;
        }

        .btn-login:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          background: linear-gradient(to right, #ff9800, #ffc107);
        }

        .btn-login-mobile {
          width: 100%;
          background: linear-gradient(to right, #ffc107, #ff9800);
          border: none;
          color: #fff;
          font-weight: 600;
          padding: 10px;
          border-radius: 8px;
          text-align: center;
          display: block;
        }

        /* Menu mobile */
        .offcanvas {
          border-right: 4px solid #008A44;
        }

        .offcanvas-header {
          background: linear-gradient(to right, #dc3545, #bd2130);
        }

        .mobile-nav-link {
          padding: 12px 15px;
          margin: 5px 0;
          transition: all 0.3s ease;
        }

        /* Mobile dropdown styling */
        .mobile-dropdown {
          margin: 5px 0;
        }

        .mobile-dropdown .nav-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 15px;
        }

        .mobile-dropdown .nav-link::after {
          margin-left: 10px;
        }

        .submenu-list {
          list-style: none;
          padding: 0;
          margin: 0;
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 0 0 8px 8px;
        }

        /* Style pour les sous-menus scrollable en mode mobile */
        .scrollable-submenu {
          max-height: 250px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #ffc107 rgba(0,0,0,0.3);
        }

        .scrollable-submenu::-webkit-scrollbar {
          width: 4px;
        }

        .scrollable-submenu::-webkit-scrollbar-track {
          background: rgba(0,0,0,0.3);
        }

        .scrollable-submenu::-webkit-scrollbar-thumb {
          background: #ffc107;
          border-radius: 10px;
        }

        .submenu-link {
          display: block;
          padding: 10px 15px 10px 40px;
          color: #fff;
          text-decoration: none;
          transition: all 0.2s ease;
          font-size: 14px;
        }

        .submenu-link:hover,
        .submenu-link.active {
          background-color: rgba(255, 255, 255, 0.1);
          color: #ffc107;
        }

        /* Espaceur pour éviter le chevauchement */
        .header-spacer {
          height: 90px; /* Hauteur de la topbar + navbar */
        }

        /* Responsive media queries pour Header */
        @media (max-width: 1199px) {
          .nav-link {
            font-size: 14px;
            padding: 8px 10px;
          }
          
          .btn-login {
            padding: 6px 15px;
            font-size: 14px;
          }
        }

        @media (max-width: 991px) {
          .topbar {
            text-align: center;
            font-size: 12px;
            padding: 5px 0;
          }
          
          .topbar-link {
            font-size: 11px;
            padding: 2px 8px;
          }

          .container {
            padding: 0 15px;
          }

          .navbar-toggler {
            margin-right: 10px;
            border: 2px solid rgba(255,255,255,0.5);
            padding: 8px 10px;
          }
          
          .logo {
            height: 45px;
          }
          
          .header-spacer {
            height: 80px;
          }
          
          .main-header {
            padding: 8px 0;
          }
        }
        
        @media (max-width: 768px) {
          .topbar {
            font-size: 10px;
            padding: 3px 0;
          }
          
          .topbar-link {
            font-size: 10px;
            padding: 1px 5px;
          }
          
          .divider {
            margin: 0 3px;
          }
          
          .logo {
            height: 40px;
          }
          
          .navbar-toggler {
            padding: 6px 8px;
          }
          
          .offcanvas {
            width: 280px;
          }
          
          .mobile-nav-link {
            padding: 10px 12px;
            font-size: 15px;
          }
          
          .submenu-link {
            padding: 8px 12px 8px 35px;
            font-size: 13px;
          }
          
          .btn-login-mobile {
            margin: 15px 0;
            padding: 12px;
            font-size: 15px;
          }
        }
        
        @media (max-width: 576px) {
          .topbar {
            display: none; /* Masquer la topbar sur très petits écrans */
          }
          
          .logo {
            height: 35px;
          }
          
          .main-header {
            padding: 5px 0;
          }
          
          .container {
            padding: 0 10px;
          }
          
          .navbar-toggler {
            padding: 5px 7px;
            margin-right: 5px;
          }
          
          .offcanvas {
            width: 250px;
          }
          
          .offcanvas-title {
            font-size: 16px;
          }
          
          .mobile-nav-link {
            padding: 8px 10px;
            font-size: 14px;
          }
          
          .submenu-link {
            padding: 6px 10px 6px 30px;
            font-size: 12px;
          }
          
          .scrollable-submenu {
            max-height: 200px;
          }
          
          .header-spacer {
            height: 60px;
          }
        }
        
        @media (max-width: 400px) {
          .logo {
            height: 30px;
          }
          
          .offcanvas {
            width: 220px;
          }
          
          .mobile-nav-link {
            font-size: 13px;
          }
          
          .submenu-link {
            font-size: 11px;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
